import useClientSideMediaQuery from 'hooks/use-client-side-media-query';
import { FC } from 'react';

import LargeNavigation from './LargeNavigation';
import SmallNavigation from './SmallNavigation';

import { topNavContent } from './top-navigation.content';
import { useRouter } from 'next/router';

const TopNavigation: FC = () => {
  const isSmall = useClientSideMediaQuery(960);
  const router = useRouter();

  // This code is important when we have homepage variants that require a different nav theme
  // Check if homepage hero variant-2 or variant-3 is visible
  // useEffect(() => {
  //   if (router.pathname !== '/' || !router.isReady) return;

  //   const variant2 = document.getElementById('homepage-hero-variant-2');
  //   const variant3 = document.getElementById('homepage-hero-variant-3');

  //   const variant2Visible =
  //     variant2 && getComputedStyle(variant2).display !== 'none';
  //   const variant3Visible =
  //     variant3 && getComputedStyle(variant3).display !== 'none';

  //   if (variant2Visible || variant3Visible) {
  //     setUseGreenThemeForHomepage(true);
  //   }
  // }, [router.isReady]);

  // homepage represented by '/'
  const routesToUseWhiteNav = [
    '/entire-world',
    '/holiday-2025',
    '/join-us',
    '/pdp/products',
  ];
  const useWhiteNav =
    routesToUseWhiteNav.includes(router.pathname) ||
    router.pathname.startsWith('/account/journey/');

  const theme = useWhiteNav ? 'white' : 'green';

  if (isSmall === null) {
    return <></>;
  }

  return (
    <>
      {isSmall ? (
        <SmallNavigation mainNavigation={topNavContent} theme={theme} />
      ) : (
        <LargeNavigation mainNavigation={topNavContent} theme={theme} />
      )}
    </>
  );
};

export default TopNavigation;
